export default {
	title: 'Configuración del Colector',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		copy: 'Copiar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		name: 'Nombre',
		placeholder: {
			name: 'Por favor ingrese nombre'
		}
	},
	table: {
		id: 'ID',
		name: 'Nombre de Definición del Colector',
		remark: 'Tipo de Colector'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		copy: 'Copiar',
		modelConfig: 'Configuración del Modelo',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	widgetForm: {
		name: 'Nombre de Definición del Colector',
		collectorType: 'Tipo de Colector',
		highFreqAccel: 'Aceleración de Alta Frecuencia',
		lowFreqAccel: 'Aceleración de Baja Frecuencia',
		longWave: 'Onda Larga',
		characteristicValue: 'Valor Característico',
		collectStrategy: 'Estrategia de Recolección',
		configName: 'Nombre de Configuración',
		configValue: 'Valor de Configuración',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			name: 'Por favor ingrese nombre de definición del colector'
		}
	},
	collectorType: {
		singleAxisSensor: 'Sensor de Eje Único',
		threeAxisSensor: 'Sensor de Tres Ejes'
	},
	configItem: {
		collectLength: 'Longitud de Recolección',
		collectFreq: 'Frecuencia de Recolección',
		collectInterval: 'Intervalo de Recolección',
		zAxisCollectLength: 'Longitud de Recolección del Eje Z',
		xyAxisCollectLength: 'Longitud de Recolección de los Ejes X/Y',
		zAxisCollectFreq: 'Frecuencia de Recolección del Eje Z',
		xyAxisCollectFreq: 'Frecuencia de Recolección de los Ejes X/Y'
	},
	lengthOptions: {
		'1K': '1K',
		'2K': '2K',
		'4K': '4K',
		'8K': '8K',
		'16K': '16K',
		'32K': '32K',
		'64K': '64K',
		'128K': '128K',
		'256K': '256K',
		'512K': '512K'
	},
	freqOptions: {
		'2560': '2560',
		'5120': '5120',
		'12800': '12800',
		'25600': '25600',
		'51200': '51200'
	},
	intervalOptions: {
		'30': '30',
		'60': '60',
		'300': '300',
		'600': '600',
		'1800': '1800',
		'3600': '3600'
	},
	collectStrategy: {
		speedCollect: 'Recolección de Velocidad',
		abnormalEncryptCollect: 'Recolección de Cifrado de Estado Anormal'
	}
}
